/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'

const $nsid = 'app.bsky.graph.follow'

type $nsid = typeof $nsid

export { $nsid }

/** Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView. */
type Main = {
  $type: 'app.bsky.graph.follow'
  via?: RepoStrongRef.Main
  subject: l.DidString
  createdAt: l.DatetimeString
}

export type { Main }

/** Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    via: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
    subject: /*#__PURE__*/ l.string({ format: 'did' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
